<template>
  <div class="content-warpper">
    <iframe
      id="inputIFrameId"
      class="iframe"
      height="400px"
      width="100%"
      frameborder="0"
      scrolling="no"
      src="/kityformula/index.html"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "formula",
  data() {
    return {};
  },

  mounted() {},

  beforeDestroy() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.content-warpper {
  margin: 0 auto;
  max-width: 860px;
}

</style>
